import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'
import { login_info } from "@/api/api.js"
import { Toast } from "vant"
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/login',
    children: [
      {
        path: 'apply',
        name: 'Apply',
        component: () => import('../views/child/Apply.vue')
      },

      {
        path: 'dynamic',
        name: 'Dynamic',
        component: () => import('../views/child/Dynamic.vue'),
      },
      {
        path: 'dynamicInfo',
        name: 'DynamicInfo',
        component: () => import('../views/child/DynamicInfo.vue'),
      },
      {
        path: 'introduce',
        name: 'Introduce',
        component: () => import('../views/child/Introduce.vue'),
      },
      {
        path: 'player',
        name: 'Player',
        component: () => import('../views/child/Player.vue'),
      },
      {
        path: 'rank',
        name: 'Rank',
        component: () => import('../views/child/Rank.vue'),
      },
      {
        path: 'vote',
        name: 'Vote',
        component: () => import('../views/child/Vote.vue'),
      },
      {
        path: 'comment',
        name: 'Comment',
        component: () => import('../views/child/Comment.vue'),
      },
      {
        path: 'groupsvotelist',
        name: 'GroupsVoteList',
        component: () => import('../views/child/GroupsVoteList.vue'),
      },
      {
        path: '/score',
        name: 'Score',
        // component: () => import('../views/child/Score.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/ad',
    name: 'Ad',
    component: () => import('../views/Ad.vue')
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/Report.vue')
  },
  {
    path: '/hidden',
    name: 'Hidden',
    component: () => import('../views/Hidden.vue')
  },
  {
    path: '/judges',
    name: 'Judges',
    component: () => import('../views/Judges.vue'),
  },
  {
    path: '/givescore',
    name: 'Givescore',
    component: () => import('../views/score/Givescore.vue'),
  },
  {
    path: '/myplayer',
    name: 'Myplayer',
    component: () => import('../views/score/Player.vue'),
  },
  {
    path: '/endscore',
    name: 'Endscore',
    component: () => import('../views/score/vote/Endscores.vue'),
  },
  {
    path: '/404',
    name: 'Notfound',
    component: () => import('../views/Notfound.vue')
  },
  {
    path: '*',
    name: '*',
    redirect: '/404'
  },
]

const router = new VueRouter({
  mode: "history",
  routes
})
//获取info
const getInfo = async (id) => {
  let { data: result } = await login_info({ action_id: id })
  sessionStorage.setItem('info', JSON.stringify(result.data))
  sessionStorage.setItem('topic', result.data.template.temproute)
  store.state.activeData.topic = result.data.template.temproute
  sessionStorage.setItem('tabarIndex', result.data.setting.setHome)
  return result
}
//判断去404、hiden
const gotoHere = () => {
  if (sessionStorage.getItem('info')) {
    let res = ''
    JSON.parse(sessionStorage.getItem('info')).hideswitch == 1 ? res = '/hidden' : res = '/404 '
    return res
  } else {
    return '/404'
  }
}
router.beforeEach(async (to, from, next) => {
  // 判断是不是去的评审页
  if (to.path == "/judges" || to.path == '/givescore' || to.path == '/myplayer' || to.path == "/endscore") {
    if (!to.query.id) {
      next('/404')
    } else {
      next()
    }
  } else {
    //如果头上没ID，去的又不是login，直接去404
    if (!to.query.id) {
      to.path == '/404' ? next() : (to.path == '/hidden' ? next() : (to.path == '/login' ? next() : next(gotoHere())))
      return
    }
    //判断是否存在info 
    if (!sessionStorage.getItem('info')) {
      //如果不存在info-->1.获取info 2.检查info中是否需要去隐藏、删除页
      try {
        const result = await getInfo(to.query.id)
        //成功获取info之后，判断删除
        if (result.data.isdel == 1) {
          to.path != '/404' ? next('/404') : next()
          return
        }
        //成功获取info之后，判断隐藏
        if (result.data.hideswitch == 1) {
          to.path != '/hidden' ? next('/hidden') : next()
          return
        }
        next({
          path: "/login",
          query: to.query
        })
      } catch (error) {
        //获取info失败直接去404
        next('/404')
      }
    } else {
      //如果头上带了id, 存在info的id与头上id不一致
      if (to.query.id && to.query.id != JSON.parse(sessionStorage.getItem('info')).id) {
        //重新获取info
        sessionStorage.clear()
        try {
          const result = await getInfo(to.query.id)
          if (result.data.isdel == 1) {
            to.path != '/404' ? next('/404') : next()
            return
          }
          //成功获取info之后，判断隐藏
          if (result.data.hideswitch == 1) {
            to.path != '/hidden' ? next('/hidden') : next()
            return
          }
          next({
            path: "/login",
            query: to.query
          })
        } catch (error) {
          next('/404')
        }
      }
      //如果存在info--->判断活动是否被隐藏
      if (JSON.parse(sessionStorage.getItem('info')).hideswitch == 1) {
        to.path != '/hidden' ? next('/hidden') : next()
        return
      }
      //如果存在info--->判断活动是否被被待删除
      if (JSON.parse(sessionStorage.getItem('info')).isdel == 1) {
        to.path != '/404' ? next('/404') : next()
        return
      }
    }
    // 判断是不是微信
    if (sessionStorage.isWeixin != 'true') {
      next()
    } else {
      if (localStorage.wxInfo) {
        //判断活动id和微信返回的acid是否相同\判断有效时间
        if (JSON.parse(localStorage.getItem('wxInfo')).acid != JSON.parse(sessionStorage.getItem('info')).id || localStorage.wxInfoTime * 1 + 3000 < Date.parse(new Date()) / 1000) {
          localStorage.removeItem("wxInfo")
          localStorage.removeItem("wxInfoTime")
          to.path != '/login' ? next({ path: "/login", query: to.query }) : next()
        }
      } else {
        to.path != '/login' ? next({ path: "/login", query: to.query }) : next()
      }
    }
    // 判断是否有评委登陆token
    // if (to.matched.some(record => record.meta.requiresAuth)) {   // 哪些需要验证
    //   if (!localStorage.getItem("judgestoken")) {      
    //     next({
    //       path: '/404',   // 验证失败要跳转的页面
    //       query:this.$route.query
    //     })
    //   } else {
    //     next()
    //   }
    // } 
    next()
  }
})
router.afterEach((to, from, next) => {
  //置顶
  if (to.name != 'Vote' && to.name != 'Rank') {
    window.scrollTo(0, 0)
  }
  //开启骨架
  if (to.name == 'Vote' || to.name == 'Rank' || to.name == 'Apply' || to.name == 'Dynamic' || to.name == 'DynamicInfo' || to.name == 'Introduce' || to.name == 'Player' || to.name == 'Judges' || to.namme == 'endscore') {
    store.state.showData.skeletonShow = true
  } else {
    store.state.showData.skeletonShow = false
  }
})

export default router
